'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SocialLoginButtonProvider = require('./SocialLoginButtonProvider');

var _SocialLoginButtonProvider2 = _interopRequireDefault(_SocialLoginButtonProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    text: 'Login with Facebook',
    icon: 'facebook-official',
    style: { background: "#3b5998" },
    activeStyle: { background: "#293e69" }
};
/**
 * Facebook login button.
 * For props check {@link SocialLoginButton}
 * @extends {SocialLoginButton}
 */
var FacebookLoginButton = function FacebookLoginButton(props) {
    return _react2.default.createElement(_SocialLoginButtonProvider2.default, { defaults: defaults, props: props });
};

exports.default = FacebookLoginButton;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-social-login-buttons/lib/buttons/FacebookLoginButton.js
// module id = 830
// module chunks = 0